<div class="container" [ngClass]="theme" (contextmenu)="onRightClick()">
  <router-outlet></router-outlet>
</div>